import * as Immutable from 'immutable';
import * as React from 'react';
import { ModuleAction } from '../../Module/_actions/ModuleActions';
import ModuleStore from '../../Module/_stores/ModuleStore';
import ModuleHandler from '../../ModuleHandler/ModuleHandler';
import Webgl from "../../Webgl/Webgl";
import { IS_SERVER } from '@af-app/config';
import AwareComponent from '@af-common/Common/_components/AwareComponent';
import AnimFrameHandler from "../../Utils/AnimFrameHandler";

export type Props = {
	id: string,
	documentWidth?: number,
	documentHeight?: number,
	documentQuality?: number,
	modules?: Immutable.OrderedMap<string, ModuleStore>,
	updateModule?: (moduleId:string, key:string, value:any) => ModuleAction;
	draw?: Function
	drawLayer?: Function
	animFrameHandler: AnimFrameHandler
	visible?: boolean
	useChunks?: boolean
	isLastVisible: boolean
};

export default class StageLayer extends AwareComponent<Props> {
	componentDidMount() {
		this.setWorkerSize();
	}

	componentDidUpdate(prevProps:Props){
		if(this.propChanged(prevProps, 'documentWidth', 'documentHeight', 'documentQuality')) {
			this.setWorkerSize();
		}
	}

	private setWorkerSize() {
		let webgl = Webgl.getInstance("worker", this.props.documentWidth * (this.props.documentQuality / 100), this.props.documentHeight * (this.props.documentQuality / 100));
		webgl.resizeInstance("worker", this.props.documentWidth * (this.props.documentQuality / 100), this.props.documentHeight * (this.props.documentQuality / 100));
	}

	private drawModules() {
		this.props.modules.map((module, id) => {
			let webgl = Webgl.getInstance("worker", this.props.documentWidth * (this.props.documentQuality / 100), this.props.documentHeight * (this.props.documentQuality / 100));
			ModuleHandler(module, webgl, this.props.documentWidth, this.props.documentHeight, this.props.documentQuality, this.props.useChunks, (key:string, value:any) => this.props.updateModule(id, key, value));
		});
		
		this.props.drawLayer && this.props.drawLayer();
		this.props.isLastVisible && this.props.draw();
	}

	render = () => {
		let frameReturn = this.props.animFrameHandler.addProcess(this.drawModules.bind(this));

		if(this.props.isLastVisible) {
			this.props.animFrameHandler.execute();
		}

		return IS_SERVER && frameReturn ? frameReturn : <></>;
	};
}